import { Box, Paragraph } from '@zillow/constellation-10';

import { RenterPaymentMethodInterface } from '@renter-hub/models/Types';
import AvailablePaymentMethods from '@renter-hub/components/AvailablePaymentMethods';

interface Props {
  formattedAddress: string;
  onPaymentMethodClick: (paymentMethod: RenterPaymentMethodInterface) => void;
}

export const DisplayPaymentMethods = ({ formattedAddress, onPaymentMethodClick }: Props) => {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.md)' }}>
      <Paragraph>{`You can use any of the linked payment methods below to make payments for ${formattedAddress}.`}</Paragraph>
      <AvailablePaymentMethods onPaymentMethodClick={onPaymentMethodClick} />
    </Box>
  );
};
